import {TipoFluxoEnum} from '../../enum/tipo-fluxo.enum';

export class FluxoSalvarModel{
  id?: number;
  titulo?: string;
  descricao?: string;
  ativo?: boolean;
  tipo?: TipoFluxoEnum;

  constructor(id?: number, titulo?: string, descricao?: string, ativo?: boolean, tipo?: TipoFluxoEnum) {
    this.id = id;
    this.titulo = titulo;
    this.descricao = descricao;
    this.ativo = ativo ?? true;
    this.tipo = tipo;
  }
}
